if(!customElements.get('cart-drawer')){
    class CartDrawer extends HTMLElement {
        constructor(){
            super();

            // open drawer by clicking icon
            document.querySelectorAll('.cart-icon').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'cart'){
                    item.addEventListener('click', (e) => {
                        this.openDrawer(e, item);
                    });
                }
            });

            // close drawer
            this.addEventListener('click', this.onDrawerClick.bind(this));
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closeDrawer.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter') this.closeDrawer();
                });
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE'){
                    this.closeDrawer();
                }
            });
        }

        connectedCallback(){
            this.onReloadUnsubscriber = PubSub.subscribe(PubSub.events.cartUpdate, (event) => {
                if(event.source === 'cart-reload'){
                    this.renderCartItems();
                }
            });

            this.onCloseUnsubscriber = PubSub.subscribe(PubSub.events.cartClose, () => {
                this.closeDrawer();
            });

            this.initializeSwiper();
        }

        disconnectedCallback(){
            if(this.onReloadUnsubscriber){
                this.onReloadUnsubscriber();
            }
        }

        openDrawer(e = null, triggerElement = null){
            if(e){
                e.preventDefault();
            }

            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.renderCartItems();

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);
        }

        addFocus(){
            setTimeout(() => {
                const links = this.querySelectorAll('.link');
                if(links.length > 0){
                    links[0].focus();
                }
            }, 100);
        }

        closeDrawer(e = null){
            if(e){
                e.preventDefault();
            }

            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        onDrawerClick(e){
            const isDrawerClicked = e.target === e.currentTarget;
            if(isDrawerClicked){
                this.closeDrawer();
            }
        }

        renderCartItems(){
            fetch(`/?section_id=cart-drawer-items`)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-cart-drawer-items');

                const cartItemsWrapper = resultsMarkup.querySelector('.cart-items-wrapper');
                const cartCheckoutButton = resultsMarkup.querySelector('button[name="checkout"]');
                const cartShippingProgressBarWrapper = resultsMarkup.querySelector(".shipping-progress-bar-wrapper");
                const cartItemSize = cartItemsWrapper.dataset.size;

                const showVendor = this.dataset.showVendor == 'true';
                const showPrice = this.dataset.showPrice == 'true';
                const showQuantity = this.dataset.showQuantity == 'true';

                if(!showVendor){
                    cartItemsWrapper.querySelectorAll('.vendor').forEach(item => {
                        item.remove();
                    });
                }
                if(!showPrice){
                    cartItemsWrapper.querySelectorAll('.cart-product-price').forEach(item => {
                        item.remove();
                    });
                }
                if(!showQuantity){
                    cartItemsWrapper.querySelectorAll('cart-quantity-selector').forEach(item => {
                        item.remove();
                    });
                }

                this.querySelector('.cart-items-wrapper').innerHTML = cartItemsWrapper.innerHTML;
                this.querySelector('.cart-drawer-checkout').setAttribute('aria-hidden', parseInt(cartItemSize) == 0);
                this.querySelector('button[name="checkout"]').innerHTML = cartCheckoutButton.innerHTML;

                // free shipping progress bar
                if(this.querySelector(".shipping-progress-bar-wrapper")){
                    this.querySelector('.shipping-progress-bar-wrapper').innerHTML = cartShippingProgressBarWrapper.innerHTML;
                    const neededPercentage = cartShippingProgressBarWrapper.dataset.percentage;
                    this.querySelector('.shipping-progress-bar-wrapper').style.setProperty('--free-shipping-progress', neededPercentage);
                }
               
            }).finally(() => {
                this.addFocus();
            });
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const itemsPerView = 2;
            const itemsPerViewMobile = 1;
            const totalSlides = parseInt(this.swiperContainer.dataset.itemsTotal);
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = 25;

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                500: { slidesPerView: visibleItemsPerView }
            }

             var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: false,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                autoHeight: false,
                spaceBetween: spaceBetween
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            // Mark clone slides as inert so keyboard focus skips duplicates
            this.swiper.slides.forEach(slide => {
                if(slide.classList.contains('swiper-slide-duplicate')){
                    slide.setAttribute('inert', '');
                    slide.setAttribute('aria-hidden', 'true');
                }
            });

            // Re-apply inert to clones after Swiper updates (loop mode re-creates clones)
            this.swiper.on("slideChange", () => {
                this.swiper.slides.forEach(slide => {
                    if(slide.classList.contains('swiper-slide-duplicate')){
                        slide.setAttribute('inert', '');
                        slide.setAttribute('aria-hidden', 'true');
                    }
                });
            });
            this.swiper.on("resize", () => {
                this.swiper.update();
            });

            this.setupFocusListeners();
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('cart-drawer', CartDrawer);
}